import { render, staticRenderFns } from "./Indicador.vue?vue&type=template&id=6b303cf1&scoped=true&"
import script from "./Indicador.vue?vue&type=script&lang=js&"
export * from "./Indicador.vue?vue&type=script&lang=js&"
import style0 from "./Indicador.vue?vue&type=style&index=0&id=6b303cf1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b303cf1",
  null
  
)

export default component.exports